import React from "react";
import { FieldValues } from "react-hook-form";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";
import FormGenerator from "../../form/FormGenerator";

export type SystemConfigurationManagementFormValues = {
    code: string;
    alias: string;
};

interface Props {
    defaultValues: FieldValues;
    handleSubmit: (form_values: SystemConfigurationManagementFormValues) => void;
    loading?: boolean;
}

const SystemConfigurationManagementForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false }) => {
    const fields: FormFieldType[] = [
        { type: FormFieldTypesAllowed.Textfield, label: "Code", id: "code", required: "Field is required" },
        { type: FormFieldTypesAllowed.Textfield, label: "Alias", id: "alias", required: "Field is required" },
    ];
    return (
        <FormGenerator
            defaultValues={defaultValues}
            formFields={fields}
            handleFormSubmit={handleSubmit}
            className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
            loading={loading}
        />
    );
}

export default SystemConfigurationManagementForm;